import { selectedCalendarsStore } from '../store/store';

export function getSelectedCalendars(primarySmtpAddress: string): string[] {
    return selectedCalendarsStore().selectedCalendars.get(primarySmtpAddress);
}
